import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const LandingPage = () => {
    const navigate = useNavigate();
    const [precio, setPrecio] = useState(null);
    const [precioOriginal, setPrecioOriginal] = useState(null);

    useEffect(() => {
        const fetchPrecio = async () => {
            try {
                const res = await fetch(`${window.REACT_APP_API_ENDPOINT}/api/precios-servicio/informe_reforma`);
                if (res.ok) {
                    const data = await res.json();
                    setPrecio(data.precio);
                    setPrecioOriginal(data.precio_original);
                }
            } catch (err) {
                console.error("Error cargando precio:", err);
            }
        };
        fetchPrecio();
    }, []);

    const precioDisplay = precio != null ? `${precio}€` : "7€";

    const PrecioTag = () => {
        if (precioOriginal != null && precio != null) {
            return (
                <>
                    <span className="line-through text-gray-400 mr-2">{precioOriginal}€</span>
                    {precio}€
                </>
            );
        }
        return <>{precioDisplay}</>;
    };

    return (
        <div>
            {/* Hero */}
            <section className="bg-gradient-to-br from-blue-50 to-blue-100 pt-16 pb-20 text-center">
                <div className="max-w-5xl mx-auto px-5">
                    <h1 className="text-4xl md:text-5xl font-bold text-brand-blue mb-5 leading-tight">
                        Descubre el coste real de reforma
                        <br />
                        <span className="text-brand-green">antes de comprar tu casa</span>
                    </h1>
                    <p className="text-lg text-brand-gray mb-8 max-w-[600px] mx-auto">
                        Negocia con datos reales. Obtén un informe detallado de reforma en
                        minutos, no en semanas.
                    </p>
                    <span className="inline-block bg-brand-green text-white px-5 py-2 rounded-full text-lg mb-8">
                        Solo <PrecioTag /> por informe
                    </span>
                    <br />
                    <button
                        onClick={() => navigate("/analizarpropiedad/nueva")}
                        className="inline-block bg-brand-yellow text-white px-10 py-4 text-xl font-semibold rounded-lg hover:-translate-y-0.5 hover:shadow-lg transition-all mt-4 cursor-pointer"
                    >
                        Analizar una vivienda
                    </button>
                    <p className="mt-4 text-sm text-gray-500">
                        Introduce los datos de tu vivienda y obtén tu informe al instante
                    </p>
                </div>
            </section>

            {/* Problemas */}
            <section className="py-20 bg-white">
                <div className="max-w-5xl mx-auto px-5">
                    <h2 className="text-center text-3xl font-bold mb-12 text-brand-blue">
                        ¿Te suena familiar?
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div className="bg-yellow-50 border-l-4 border-brand-yellow p-8 rounded-r-lg">
                            <h3 className="text-red-600 font-bold text-lg mb-2">
                                "No sé cuánto me va a costar la reforma"
                            </h3>
                            <p className="text-brand-gray">
                                Ves una casa que te gusta pero necesita reforma. ¿Son 20.000€?
                                ¿50.000€? Sin saberlo, no puedes calcular si el precio es justo.
                            </p>
                        </div>
                        <div className="bg-yellow-50 border-l-4 border-brand-yellow p-8 rounded-r-lg">
                            <h3 className="text-red-600 font-bold text-lg mb-2">
                                "El vendedor no quiere bajar el precio"
                            </h3>
                            <p className="text-brand-gray">
                                Sin datos concretos, no tienes argumentos para negociar. El vendedor
                                dice que "está bien así" y tú no puedes demostrar lo contrario.
                            </p>
                        </div>
                        <div className="bg-yellow-50 border-l-4 border-brand-yellow p-8 rounded-r-lg">
                            <h3 className="text-red-600 font-bold text-lg mb-2">
                                "Conseguir presupuestos lleva semanas"
                            </h3>
                            <p className="text-brand-gray">
                                Para cada casa que visitas necesitarías traer un arquitecto o pedir
                                presupuestos. Imposible cuando estás viendo 10 viviendas.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Solución */}
            <section className="py-20 bg-brand-light">
                <div className="max-w-5xl mx-auto px-5">
                    <h2 className="text-center text-3xl font-bold mb-12 text-brand-blue">
                        Cómo funciona
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-12">
                        <div className="text-center p-8">
                            <div className="w-16 h-16 bg-brand-green text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-5">
                                1
                            </div>
                            <h3 className="text-brand-blue font-bold text-lg mb-2">
                                Introduce los datos
                            </h3>
                            <p className="text-brand-gray">
                                Rellena la información básica de la vivienda que te interesa y sube fotos.
                            </p>
                        </div>
                        <div className="text-center p-8">
                            <div className="w-16 h-16 bg-brand-green text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-5">
                                2
                            </div>
                            <h3 className="text-brand-blue font-bold text-lg mb-2">
                                Nuestra IA analiza todo
                            </h3>
                            <p className="text-brand-gray">
                                Analizamos fotos, descripción y características para detectar qué
                                necesita reforma.
                            </p>
                        </div>
                        <div className="text-center p-8">
                            <div className="w-16 h-16 bg-brand-green text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-5">
                                3
                            </div>
                            <h3 className="text-brand-blue font-bold text-lg mb-2">
                                Recibe tu informe
                            </h3>
                            <p className="text-brand-gray">
                                En minutos tienes un desglose completo de costes y el valor
                                post-reforma.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Ejemplo */}
            <section className="py-20 bg-white">
                <div className="max-w-5xl mx-auto px-5">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                        <div>
                            <h2 className="text-3xl font-bold text-brand-blue mb-5">
                                Un informe que te da poder de negociación
                            </h2>
                            <ul className="mb-8 space-y-3">
                                {[
                                    "Desglose de todas las partidas de reforma necesarias",
                                    "Coste estimado por cada actuación (suelos, baños, cocina...)",
                                    "Comparativa reforma estándar vs. premium",
                                    "Valor estimado de la vivienda post-reforma",
                                    "ROI de la inversión en cada escenario",
                                ].map((item, i) => (
                                    <li key={i} className="pl-8 relative text-brand-gray">
                                        <span className="absolute left-0 text-brand-green font-bold">
                                            ✓
                                        </span>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                            <button
                                onClick={() => navigate("/analizarpropiedad/nueva")}
                                className="inline-block bg-brand-yellow text-white px-10 py-4 text-xl font-semibold rounded-lg hover:-translate-y-0.5 hover:shadow-lg transition-all cursor-pointer"
                            >
                                Ver ejemplo completo
                            </button>
                        </div>
                        <div className="bg-brand-light rounded-xl p-8 border-2 border-gray-200">
                            <h4 className="text-brand-blue font-bold text-center mb-5">
                                Ejemplo: Piso en Granada, 85m²
                            </h4>
                            {[
                                ["Suelos (laminado)", "2.550€"],
                                ["Pintura completa", "1.275€"],
                                ["Baño completo", "4.200€"],
                                ["Cocina (muebles + elect.)", "6.800€"],
                                ["Instalación eléctrica", "3.400€"],
                                ["Ventanas (4 uds)", "2.400€"],
                            ].map(([label, price], i) => (
                                <div
                                    key={i}
                                    className="flex justify-between py-3 border-b border-gray-300"
                                >
                                    <span>{label}</span>
                                    <span>{price}</span>
                                </div>
                            ))}
                            <div className="flex justify-between py-3 font-bold text-brand-green text-lg">
                                <span>TOTAL REFORMA</span>
                                <span>20.625€</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Precio */}
            <section className="py-20 bg-brand-blue text-white text-center">
                <div className="max-w-5xl mx-auto px-5">
                    <h2 className="text-3xl font-bold mb-5">Un precio que se paga solo</h2>
                    <p className="text-lg opacity-90">
                        Si consigues negociar aunque sea un 1% de descuento en una casa de
                        200.000€, te ahorras 2.000€
                    </p>
                    <div className="bg-white text-brand-gray max-w-md mx-auto mt-10 p-10 rounded-2xl shadow-[0_20px_40px_rgba(0,0,0,0.2)]">
                        <div className="text-5xl font-bold text-brand-green">
                            <PrecioTag /> <span className="text-2xl text-gray-500">/ informe</span>
                        </div>
                        <p className="text-gray-600 my-5">Pago único por vivienda analizada</p>
                        <ul className="text-left mb-8 space-y-2">
                            {[
                                "Análisis completo con IA",
                                "Desglose de todas las partidas",
                                "Costes actualizados de tu zona",
                                "Valor post-reforma estimado",
                                "Informe descargable en PDF",
                            ].map((item, i) => (
                                <li key={i} className="pl-7 relative">
                                    <span className="absolute left-0 text-brand-green">✓</span>
                                    {item}
                                </li>
                            ))}
                        </ul>
                        <button
                            onClick={() => navigate("/analizarpropiedad/nueva")}
                            className="inline-block bg-brand-yellow text-white px-10 py-4 text-lg font-semibold rounded-lg hover:-translate-y-0.5 hover:shadow-lg transition-all cursor-pointer"
                        >
                            Obtener mi informe
                        </button>
                    </div>
                </div>
            </section>

            {/* CTA Final */}
            <section className="py-20 text-center bg-brand-light">
                <div className="max-w-5xl mx-auto px-5">
                    <h2 className="text-3xl font-bold text-brand-blue mb-4">
                        Analiza tu primera vivienda ahora
                    </h2>
                    <p className="text-brand-gray text-lg mb-8">
                        Introduce los datos de la vivienda y recibe tu informe en minutos
                    </p>
                    <button
                        onClick={() => navigate("/analizarpropiedad/nueva")}
                        className="bg-brand-yellow text-white px-10 py-4 text-xl font-semibold rounded-lg cursor-pointer hover:opacity-90 transition-opacity"
                    >
                        Analizar vivienda ({precioDisplay})
                    </button>
                    <p className="mt-4 text-sm text-gray-500">
                        Pago seguro con tarjeta. Informe en menos de 5 minutos.
                    </p>
                </div>
            </section>
        </div>
    );
};

export default LandingPage;
